<div class="role-mgmt">
  <jml-lib-dynamic-table
    [tableData]="tableData"
    [token]="token$ | async"
    [preselectionId]="id$ | async"
    (entitySelection)="onEntitySelection($event)"
    [activateTableState]="true"
  ></jml-lib-dynamic-table>

  <div *ngIf="!!entryId" class="role-mgmt__editor">
    <div *ngIf="!isSingleRole; else rightActionsEditor" class="bg-white">
      <jml-lib-entity-view configName="SecurityRole" [entryId]="entryId"></jml-lib-entity-view>
    </div>

    <ng-template #rightActionsEditor>
      <jml-lib-right-actions-editor [ownerId]="entryId"></jml-lib-right-actions-editor>
    </ng-template>
  </div>
</div>
